import QuoteCTA from '../components/QuoteCTA.jsx';

const model = [
  ['You', 'Drawing and volumes', 'Your specs, your tolerances, your schedule.'],
  ['MachineX America · Austin, TX', 'Engineering, QC, logistics', 'Your single contract and point of contact.'],
  ['Partner plants in Asia', 'Certified production', 'Matched to each process: machining, molding, casting.'],
  ['Your facility', 'Duty-paid delivery', 'Inspected parts with reports, customs cleared.'],
];

const principles = [
  ['We answer for the part', 'If a lot misses spec, fixing it is our problem, not your supplier-management project.'],
  ['Landed cost, not factory price', 'Our quotes include tariffs, freight and customs, so you compare real numbers.'],
  ['Your drawings stay confidential', 'We sign NDAs before files are shared and control who sees them.'],
];

export default function About() {
  return (
    <>
      <section className="grid grid-cols-2 items-end gap-20 px-[120px] pt-[240px] tablet:grid-cols-1 tablet:px-6 tablet:pt-[116px]">
        <div className="flex flex-col gap-7">
          <p className="mx-section-label">About MachineX America</p>
          <h1 className="m-0 font-display text-[72px] font-medium leading-[1.04] tracking-[-.02em] tablet:text-[44px] tablet:leading-[1.08]">A U.S. company that runs your overseas production</h1>
        </div>
        <p className="m-0 text-[20px] leading-[1.65] text-[#C9CAE0]">MachineX America was established over a decade ago to supply machined components to a U.S. oilfield service company. The same model now serves oil and gas and data center customers: we own the relationship with the factory, the inspection and the delivery, so our customers do not have to.</p>
      </section>

      <section className="px-[120px] pt-24 tablet:px-6">
        <img src="/media/images/about-engineering-office.jpg" alt="Engineering drawing, machined flange, calipers and CAD model on a desk at dusk" loading="lazy" className="block h-[480px] w-full rounded-3xl border border-[#2A2E6E] object-cover" />
      </section>

      <section className="flex flex-col gap-12 px-[120px] pt-[120px] tablet:px-6">
        <h2 className="mx-section-title text-5xl leading-[1.1] tablet:text-[32px]">How the model works</h2>
        <div className="grid grid-cols-4 items-stretch gap-5 tablet:grid-cols-1">
          {model.map(([label, title, text], index) => (
            <div key={title} className={`flex flex-col gap-3 rounded-[20px] border px-7 py-8 ${index === 1 ? 'border-[#E8773A] bg-[#10134A]' : 'border-[#2A2E6E]'}`}>
              <span className={`text-[14px] ${index === 1 ? 'text-[#F29A63]' : 'text-[#9A9CC4]'}`}>{label}</span>
              <strong className="font-display text-[22px] font-semibold">{title}</strong>
              <span className={`text-[15px] leading-[1.6] ${index === 1 ? 'text-[#C9CAE0]' : 'text-[#B9BBDA]'}`}>{text}</span>
            </div>
          ))}
        </div>
      </section>

      <section className="grid grid-cols-2 items-center gap-20 px-[120px] pt-[140px] tablet:grid-cols-1 tablet:px-6">
        <img src="/media/images/finished-parts-rows.jpg" alt="Rows of finished machined parts on an inspection table" loading="lazy" className="block h-[480px] w-full rounded-3xl object-cover" />
        <ul className="m-0 flex list-none flex-col p-0">
          {principles.map(([title, text], index) => (
            <li key={title} className={`flex flex-col gap-2 border-t border-[#2A2E6E] py-7 ${index === principles.length - 1 ? 'border-b' : ''}`}>
              <strong className="font-display text-2xl font-semibold leading-[normal]">{title}</strong>
              <span className="text-[16px] leading-[1.6] text-[#B9BBDA]">{text}</span>
            </li>
          ))}
        </ul>
      </section>

      <section className="mx-facts-section mt-[140px] px-[120px] py-20 tablet:mx-4 tablet:px-6">
        <dl className="m-0 grid grid-cols-2 gap-8 tablet:grid-cols-1">
          <div className="flex flex-col gap-2"><dt className="text-[14px] text-[#9A9CC4]">Legal name</dt><dd className="m-0 font-display text-[20px] font-semibold">MachineX America LLC</dd></div>
          <div className="flex flex-col gap-2"><dt className="text-[14px] text-[#9A9CC4]">Headquarters</dt><dd className="m-0 font-display text-[20px] font-semibold">Austin, Texas</dd></div>
        </dl>
      </section>

      <QuoteCTA title="Let us quote your next part" text="Tell us what you build. We reply within 24 hours." />
    </>
  );
}
